import { clarityService } from "@/lib/clarity";

clarityService.initialize();
